import React from 'react';

/**
 * 개인정보 수집 및 이용 약관 컴포넌트
 * 전시회 사전등록 시 필요한 개인정보 처리방침을 보여줍니다.
 */
export const PrivacyPolicy: React.FC = () => {
  return (
    <div className="space-y-6 text-sm text-gray-700">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">
          개인정보 수집 및 이용 약관
        </h3>
        <p className="mb-4">
          본 약관은 전시회 사전등록 서비스 이용 시 개인정보 처리에 관한 사항을 규정합니다.
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">1. 개인정보의 수집 및 이용 목적</h4>
        <ul className="list-disc pl-5 space-y-1">
          <li>전시회 사전등록 서비스 제공</li>
          <li>등록자 신원 확인 및 입장권 발급</li>
          <li>전시회 관련 안내 및 알림 서비스</li>
          <li>전시회 참가 통계 및 분석</li>
          <li>고객 문의 응답 및 서비스 개선</li>
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">2. 수집하는 개인정보 항목</h4>
        <div className="space-y-2">
          <div>
            <p className="font-medium">필수 항목:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>이름</li>
              <li>연락처(휴대전화번호)</li>
              <li>성별</li>
              <li>연령대</li>
              <li>거주지역</li>
            </ul>
          </div>
          <div>
            <p className="font-medium">선택 항목:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>마케팅 활용 동의 여부</li>
              <li>SMS 수신 동의 여부</li>
              <li>차기 전시회 관련 안내 문자 수신 동의 여부</li>
            </ul>
          </div>
        </div>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">3. 개인정보의 보유 및 이용 기간</h4>
        <ul className="list-disc pl-5 space-y-1">
          <li>전시회 종료 후 3개월까지 보관</li>
          <li>법령에 따라 보관이 필요한 경우 해당 기간까지 보관</li>
          <li>개인정보 수집 목적 달성 시 즉시 파기</li>
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">4. 개인정보의 제3자 제공</h4>
        <ul className="list-disc pl-5 space-y-1">
          <li>원칙적으로 개인정보를 제3자에게 제공하지 않습니다</li>
          <li>법령에 따라 요구받는 경우 예외적으로 제공할 수 있습니다</li>
          <li>제3자 제공 시 사전에 동의를 받겠습니다</li>
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">5. 개인정보 처리 업무 위탁</h4>
        <ul className="list-disc pl-5 space-y-1">
          <li>SMS 발송 업무: NHN Cloud</li>
          <li>데이터 저장 및 관리: Supabase</li>
          <li>위탁업체와 개인정보 보호 계약을 체결하여 관리하고 있습니다</li>
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">6. 개인정보 보호를 위한 기술적/관리적 조치</h4>
        <ul className="list-disc pl-5 space-y-1">
          <li>개인정보 암호화 저장</li>
          <li>접근 권한 관리 및 제한</li>
          <li>개인정보 처리 시스템 접근 기록 보관</li>
          <li>개인정보 처리 직원의 최소화 및 교육</li>
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">7. 정보주체의 권리</h4>
        <ul className="list-disc pl-5 space-y-1">
          <li>개인정보 처리 현황 통지 요구</li>
          <li>개인정보 열람 요구</li>
          <li>개인정보 정정·삭제 요구</li>
          <li>개인정보 처리 정지 요구</li>
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">8. 개인정보 보호책임자</h4>
        <div className="bg-gray-50 p-3 rounded">
          <p><strong>담당부서:</strong> 전시회 운영팀</p>
          <p><strong>연락처:</strong> 02-1234-5678</p>
          <p><strong>이메일:</strong> privacy@urbanbreak.com</p>
        </div>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">9. 개인정보 침해 신고 및 상담</h4>
        <p className="mb-2">개인정보 침해 신고, 상담이나 신고처리에 대하여 불만이 있으시면 아래의 기관에 문의하실 수 있습니다.</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>개인정보 침해신고센터: (국번없이) 1388 (privacy.kisa.or.kr)</li>
          <li>개인정보 분쟁조정위원회: (국번없이) 1833-6972 (privacy.go.kr)</li>
          <li>대검찰청 사이버범죄수사단: (국번없이) 1301 (spo.go.kr)</li>
          <li>경찰청 사이버안전국: (국번없이) 182 (cyberbureau.police.go.kr)</li>
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">10. 개인정보 처리방침 변경</h4>
        <ul className="list-disc pl-5 space-y-1">
          <li>본 개인정보 처리방침은 관련 법률 및 지침의 변경 또는 회사 정책의 변경에 따라 개정될 수 있습니다.</li>
          <li>개인정보 처리방침이 변경되는 경우 변경 사항을 게시하거나 개별 통지하겠습니다.</li>
          <li>변경된 개인정보 처리방침은 게시한 날로부터 효력을 발생합니다.</li>
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">11. 동의 철회 방법</h4>
        <ul className="list-disc pl-5 space-y-1">
          <li>이용자는 언제든지 개인정보 수집 및 이용 동의를 철회할 수 있습니다.</li>
          <li>동의 철회는 개인정보 보호책임자에게 서면, 전화 또는 이메일로 연락하여 요청할 수 있습니다.</li>
          <li>동의 철회 시 서비스 이용에 제한이 있을 수 있습니다.</li>
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">12. 개인정보 자동 수집 장치의 설치·운영 및 거부</h4>
        <ul className="list-disc pl-5 space-y-1">
          <li>회사는 이용자의 편의를 위하여 쿠키(cookie)를 사용할 수 있습니다.</li>
          <li>쿠키는 웹사이트가 이용자의 컴퓨터 브라우저에 전송하는 소량의 정보입니다.</li>
          <li>이용자는 쿠키 설정을 거부할 수 있으며, 이 경우 일부 서비스 이용에 제한이 있을 수 있습니다.</li>
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">13. 개인정보 보호 교육</h4>
        <ul className="list-disc pl-5 space-y-1">
          <li>개인정보를 처리하는 직원은 정기적으로 개인정보 보호 교육을 받습니다.</li>
          <li>개인정보 처리 시스템의 접근 권한을 최소화하고 정기적으로 점검합니다.</li>
          <li>개인정보 처리 관련 내부 규정을 마련하고 준수합니다.</li>
        </ul>
      </div>

      <div className="border-t pt-4">
        <p className="text-xs text-gray-500">
          본 약관은 2025년 7월 16일부터 시행됩니다.
        </p>
        <p className="text-xs text-gray-500 mt-2">
          개인정보 처리방침 버전: v1.0 (최종 수정일: 2025년 7월 16일)
        </p>
      </div>
    </div>
  );
}; 